import { Alert } from "@interstate/components/Alert";
import { ErrorMessages } from "@coxauto-ui/cxm/communications/util";
import { StyledContainerAlert } from "./styled";

export interface RepairOrderTextingDisabledAlertProps {
  autoLeadId: string | null;
  repairOrderId: string | null;
}

export function RepairOrderTextingDisabledAlert({
  autoLeadId,
  repairOrderId
}: RepairOrderTextingDisabledAlertProps) {
  if (!repairOrderId || autoLeadId) {
    return null;
  }

  return (
    <StyledContainerAlert>
      <Alert
        data-testid="repair-order-texting-disabled-alert"
        id="RepairOrderTextingLockedAlert"
        role="warning"
        type="caution"
      >
        {ErrorMessages.REPAIR_ORDER_TEXTING_DISABLED}
      </Alert>
    </StyledContainerAlert>
  );
}
